export default "<div class=\"body modal-backdrop\">\n    <div class=\"loader\"><span></span><span></span></div>\n</div>"